
export const refundLists_api = {
  title: "退款列表",
  url: "refundLists",
  method: "post",
  param: {},
};
// refundListsDownload

export const export_api = {
  title: "退款导出",
  url: "refundListsDownload",
  method: "post",
  param: {},
};




// WEBPACK FOOTER //
// ./src/views/base/refund/desc.js